import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_ACTIVIDADES_ACADEMICAS,
  ALL_ACTIVIDADES_ACADEMICAS,
  LOADING_ALL_ACTIVIDADES_ACADEMICAS,
} from './ActividadesAcademicasReducer';
import {
  deleteActividadesAcademicasService,
  allActividadesAcademicasService,
  oneActividadesAcademicasService,
  saveActividadesAcademicasService,
} from './ActividadesAcademicasService';

export const allActividadesAcademicasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ACTIVIDADES_ACADEMICAS, payload: true });
    const res = await allActividadesAcademicasService(params);
    dispatch({ type: ALL_ACTIVIDADES_ACADEMICAS, payload: res.data });
    dispatch({ type: LOADING_ALL_ACTIVIDADES_ACADEMICAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ACTIVIDADES_ACADEMICAS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveActividadesAcademicasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveActividadesAcademicasService(id, data);
    notify(res.data.message);
    await allActividadesAcademicasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoActividadesAcademicasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ACTIVIDADES_ACADEMICAS, payload: data });
};

export const oneActividadesAcademicasAction = async (dispatch, id) => {
  try {
    const res = await oneActividadesAcademicasService(id);
    await setActivoActividadesAcademicasAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteActividadesAcademicasAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteActividadesAcademicasService(id);
    await setActivoActividadesAcademicasAction(dispatch, null);
    await allActividadesAcademicasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
